<template>
  <div class="cart">
    <div class="card-cart">
      <div class="cart-title">
        <back-button
          :text="$t('views.cart.back')"
          @click="goToHome()"
        />
        <span class="page">{{ $t('views.cart.title') }}</span>
      </div>
      <card-cart
        :cart-items="cartItems"
        :budget-managements="budgetManagements"
        @deleteOfferedItem="deleteOfferedItem"
      />
    </div>
    <div class="card-total">
      <span class="text-total">{{ $t('views.cart.total') }}</span>
      <span class="text-value">{{ formatMoney(totalValue) }}</span>
    </div>
    <div class="content-button">
      <rectoplus-button
        class="button-next"
        elevation="0"
        :text="$t('views.cart.buttons.next')"
        @click="goToCheckout()"
      />
    </div>

    <validation-modal
      v-if="showValidationModal"
      :validation-result="validationResult"
      @close="showValidationModal = false"
    />

    <confirmation-modal
      v-if="showConfirmationModal"
      :title="$t('views.cart.confirmation_modal.title')"
      :message="$t('views.cart.confirmation_modal.message')"
      :confirm-text="$t('views.cart.confirmation_modal.confirm_text')"
      :cancel-text="$t('views.cart.confirmation_modal.cancel_text')"
      @confirm="proceedToCheckout()"
      @cancel="showConfirmationModal = false"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import BackButton from '@/components/buttons/BackButton.vue';
import CardCart from '@/components/cards/cart/CardCart.vue';
import RectoplusButton from '@/components/buttons/RectoplusButton.vue';
import ValidationModal from '@/components/modals/ValidationModal.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import formatMoney from '@/mixins/formatMoney';

export default {
  name: 'Cart',
  components: {
    BackButton,
    CardCart,
    RectoplusButton,
    ValidationModal,
    ConfirmationModal,
  },

  mixins: [formatMoney],

  data() {
    return {
      total: 0,
      showValidationModal: false,
      showConfirmationModal: false,
      hasMissingBudgetRelations: false,
    };
  },

  computed: {
    ...mapGetters({
      cartItems: 'getCartItems',
      validationResult: 'getValidationResult',
      budgetManagements: 'getBudgetManagements',
      business: 'getBusiness',
      creditOfferedBudgetRelations: 'getCreditOfferedBudgetRelations',
    }),
    totalValue() {
      const quantities = this.cartItems.map((item) => Number(item.total_value));
      if (quantities.length <= 0) return 0;
      return quantities.reduce((previousValue, currentValue) => previousValue + currentValue);
    },
  },

  watch: {
    validationResult: {
      handler(value) {
        this.showValidationModal = value.length > 0;
      },
      deep: true,
    },
  },

  mounted() {
    this.validateCartItems();
    this.fetchBudgetManagements({ business_id: this.business.id });
  },

  methods: {
    ...mapActions([
      'fetchCartItems',
      'fetchBudgetManagements',
      'deleteCartItem',
      'updateCartItem',
      'initLoading',
      'validateCartItems',
    ]),

    deleteOfferedItem(item) {
      this.initLoading();
      this.deleteCartItem(item);
    },

    goToCheckout() {
      if (this.creditOfferedBudgetRelations.some((relation) => !relation.budget_management_id) && this.budgetManagements.length > 0) {
        this.showConfirmationModal = true;
      } else {
        this.proceedToCheckout();
      }
    },

    proceedToCheckout() {
      this.showConfirmationModal = false;
      this.fetchCartItems();
      this.$router.push({ name: 'checkout' });
    },

    editOfferedItem(item) {
      this.initLoading();
      this.updateCartItem(item);
    },

    validateOffered(errors) {
      this.errors = [...errors];
    },

    goToHome() {
      this.$router.push({ name: 'home' });
    },
  },
};
</script>
<style lang="scss" scoped>
.cart {
  background: $dashboard_background;
  min-height: 100vh;
  display: flex;
  padding: 2em 2em 2em 16em;
  flex-direction: column;

  .card-cart {
    .cart-title {
      display: flex;
      width: 60%;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 50px;

      .page {
        font-size: 1.5em;
        font-weight: bold;
      }

      .content-cart-button {
        display: flex;
        cursor: pointer;

        .cart-icon {
          display: flex;
          flex-direction: column;
          position: relative;

          .number-cart-itens {
            color: $color_primary;
            font-size: 0.875em;
            font-weight: bold;
            position: absolute;
            bottom: 16px;
            right: 8px;
          }
        }

        .text-cart {
          color: $color_primary;
          font-weight: bold;
        }
      }
    }
  }

  .card-total {
    background-color: $card_cart;
    margin: 20px 0px;
    padding: 30px;
    border-radius: 10px;
    text-align: end;

    .text-total {
      font-size: 1.5em;
      font-weight: bold;
      margin-right: 16px;
      color: $color_gray;
    }

    .text-value {
      font-size: 1.5em;
      font-weight: bold;
    }
  }

  .content-button {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    .button-next {
      width: 100%;
      max-width: 300px;
      height: 56px;
    }
  }
}
</style>
